export default __webpack_public_path__ + "static/media/Dane_van_Rensburg.12597a4d.jpeg";